import { render, staticRenderFns } from "./columnsWhite.vue?vue&type=template&id=f4d2b282&scoped=true&"
import script from "./columnsWhite.vue?vue&type=script&lang=js&"
export * from "./columnsWhite.vue?vue&type=script&lang=js&"
import style0 from "./columnsWhite.vue?vue&type=style&index=0&id=f4d2b282&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d2b282",
  null
  
)

export default component.exports